<template>
    <page-hero
        :title="title"
        :subtitle="subtitle"
    >
        <template
            v-if="$slots.default"
            #actions
        >
            <slot />
        </template>
    </page-hero>
</template>

<script>
export default {
    name: 'RPageHeader',
    props: {
        title: {
            type: String,
            default: null
        },
        subtitle: {
            type: String,
            default: null
        }
    },
}
</script>
